// ABOUTME: Manages dark mode theme state
// ABOUTME: Persists theme preference to localStorage using Zustand

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ThemeMode = 'light' | 'dark' | 'system'

export interface ThemeState {
  mode: ThemeMode
  resolvedMode: 'light' | 'dark'
}

interface ThemeActions {
  setMode: (mode: ThemeMode) => void
  setResolvedMode: (mode: 'light' | 'dark') => void
}

type ThemeStore = ThemeState & ThemeActions

const initialState: ThemeState = {
  mode: 'system',
  resolvedMode: 'light',
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      ...initialState,

      setMode: (mode: ThemeMode) => {
        set({ mode })
      },

      setResolvedMode: (mode: 'light' | 'dark') => {
        set({ resolvedMode: mode })
      },
    }),
    {
      name: 'gentleman-theme-store',
    }
  )
)
